<template>
	<div>
		<div class="print-solicitacao" v-if="exibir">
			<div class="row print">
				<flCabecalho widthimg="40" widthimg2="40" top="16" />
			</div>

			<!-- <p class="text-success" v-if="form.nome_usuario_assinou != ''" style="margin-top:20px;margin-bottom:6px">
			<i class="fa fa-fw fa-check-circle"></i>{{_traducao('global','assinadoPor')}} <strong>{{form.nome_usuario_assinou}}</strong> {{_traducao('global','em').toLowerCase()}} <strong> {{form.data_assinatura | dataTempo}}</strong>
		</p> -->

			<div class="table-responsive" style="margin-top: 8px">
				<table style="width: 100%">
					<tr>
						<td>
							<!-- diário de bordo -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="9" style="background: #eee" class="text-center">
											{{ trecho.numero_diario }} - {{ _traducao('global', 'diarioDeBordo').toUpperCase() }}<br />
											<!-- <SMALL style="margin-bottom:0px" v-if="form.nome_operador_assinou == ''">ESSE DIÁRIO DE BORDO NÃO É VÁLIDO PARA A ANAC</SMALL> -->
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'numero') }}:</th>
										<th>{{ _traducao('global', 'data') }}:</th>
										<th>{{ _traducao('menuVoo', 'menuVprefixo') }}:</th>
										<th>{{ _traducao('global', 'codinome') }}:</th>
										<th>{{ _traducao('global', 'categoria') }}:</th>
										<th>{{ _traducao('global', 'tipo') }}:</th>
										<th>{{ _traducao('global', 'fabricante') }}:</th>
										<th>{{ _traducao('menuVoo', 'menuVmodelo') }}:</th>
										<th>{{ _traducao('menuManutencao', 'menuMnumSerie') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ trecho.numero_diario }}
										</td>
										<td>
											{{ form.acionamento.split(' ')[0] }}
										</td>
										<td>
											{{ aeronave.prefixo }}
										</td>
										<td>
											{{ aeronave.codinome }}
										</td>
										<td>
											{{ aeronave.categoria }}
										</td>
										<td>
											<span v-if="aeronave.tipo == 'H'">{{ _traducao('cadAeronave', 'helicoptero').toUpperCase() }}</span>
											<span v-if="aeronave.tipo == 'A'">{{ _traducao('cadAeronave', 'aviao').toUpperCase() }}</span>
										</td>
										<td>
											{{ aeronave.fabricante }}
										</td>
										<td>
											{{ aeronave.modelo }}
										</td>
										<td>
											{{ aeronave.serial_number == null || aeronave.serial_number == '' ? 'N/A' : aeronave.serial_number }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- manutencao -->
							<table v-if="tipo == 'C' || tipo == 'I'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="7" style="background: #eee" class="text-center">
											{{ _traducao('global', 'manutencao').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th>Tipo da última intervenção:</th>
										<th>Tipo da próxima intervenção:</th>
										<th>
											Horas Célula Próx. Inspeção:
											<!-- {{_traducao('global','horasDeCelulaParaAProxima')}}:  -->
										</th>
										<th>
											Responsável pelo Retorno:
											<!-- {{_traducao('global','responsavelPelaAprovacao')}}:  -->
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ form.descricao_ultima_inspecao }}
											<small>({{ form.ultima_intervencao | data }})</small>
										</td>
										<td>
											{{ form.descricao_proxima_inspecao }}
											<small>({{ form.proxima_intervencao | data }})</small>
										</td>
										<td>
											<span v-if="form.horimetro_proxima == 0"> N/A </span>
											<span v-else> {{ form.horimetro_proxima | horimetro }} <small>(Horimetro)</small> </span>
										</td>
										<td>
											{{ form.nome_usuario_retorno | na }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- <pre>
			{{motores}}
		</pre> -->

							<!-- ciclos toais -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="8" style="background: #eee" class="text-center">
											CICLOS TOTAIS
											<small>(PARCIAIS)</small>
										</th>
									</tr>
									<tr>
										<th>Hor. Inicial Célula:</th>
										<th>Hor. Final Célula:</th>
										<th>
											Total de Partidas:
											<!-- {{_traducao('global','horasDeCelulaParaAProxima')}}:  -->
										</th>
										<th>
											Total de Pousos:
											<!-- {{_traducao('global','responsavelPelaAprovacao')}}:  -->
										</th>
										<th v-if="aeronave.tipo == 'H'">
											Total de Gancho:
											<!-- {{_traducao('global','responsavelPelaAprovacao')}}:  -->
										</th>
										<th v-if="aeronave.tipo == 'H'">
											Total de Guincho:
											<!-- {{_traducao('global','responsavelPelaAprovacao')}}:  -->
										</th>
										<th>Total de Ciclos NG:</th>
										<th>Total de Ciclos NF:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ form.horimetro_inicial | horimetro }}
										</td>
										<td>
											{{ form.horimetro_final | horimetro }}
										</td>
										<td>
											{{ Number(form.total_partidas) + Number(form.partidas) }}
											<small>({{ Number(form.partidas) }})</small>
										</td>
										<td>
											{{ Number(form.total_pousos) + Number(form.pousos) }}
											<small>({{ Number(form.pousos) }})</small>
										</td>
										<td v-if="aeronave.tipo == 'H'">
											{{ Number(form.total_gancho) + Number(form.gancho) }}
											<small>({{ Number(form.gancho) }})</small>
										</td>
										<td v-if="aeronave.tipo == 'H'">
											{{ Number(form.total_guincho) + Number(form.guincho) }}
											<small>({{ Number(form.guincho) }})</small>
										</td>
										<td>
											<div v-for="(mt, idx) in motores" :key="idx">
												<div>
													{{ (Number(mt.ciclo_ng) + Number(form.ciclo_ng)) | horimetro2 }}
													<small>({{ form.ciclo_ng | horimetro2 }})</small>
												</div>
											</div>
											<div v-if="motores.length == 0">
												N/A <small>({{ form.ciclo_ng | horimetro2 }})</small>
											</div>
										</td>
										<td>
											<div v-for="(mt, idx) in motores" :key="idx">
												<div>
													{{ (Number(mt.ciclo_nf) + Number(form.ciclo_nf)) | horimetro2 }}
													<small>({{ form.ciclo_nf | horimetro2 }})</small>
												</div>
											</div>
											<div v-if="motores.length == 0">
												N/A <small>({{ form.ciclo_nf | horimetro2 }})</small>
											</div>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- Motor e Horário -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="2" style="background: #eee" class="text-center">HORÁRIOS</th>
										<th colspan="3" style="background: #eee" class="text-center">
											{{ _traducao('global', 'trecho').toUpperCase() }}
										</th>
										<!-- <th colspan="1" style="background: #EEE" class="text-center">
                        {{_traducao('global','horimetro').toUpperCase()}}
                    </th> -->
									</tr>
									<tr>
										<th>{{ _traducao('global', 'acionamento') }}:</th>
										<th>{{ _traducao('global', 'decolagem') }}:</th>
										<th>{{ _traducao('global', 'partida').capitalize() }}:</th>
										<th>{{ _traducao('global', 'estado') }}:</th>
										<th>{{ _traducao('global', 'cidade') }}:</th>
										<!-- <th>
                        {{_traducao('global','inicial')}}:
                    </th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ form.acionamento }} ({{ _fusoHorario }})<br />
											<small>&nbsp;{{ form.acionamento_utc }} (UTC) </small>
										</td>
										<td v-show="form.decolagem != ''">
											{{ form.decolagem }} ({{ _fusoHorario }})<br />
											<small>&nbsp;{{ form.decolagem_utc }} (UTC)</small>
										</td>
										<td v-if="form.decolagem == ''">N/A</td>
										<td>
											{{ form.de_select.sigla }}
										</td>
										<td>
											{{ form.nome_estado_de }}
										</td>
										<td>
											{{ form.nome_cidade_de }}
										</td>
										<!-- <td>
                        {{form.horimetro_inicial | horimetro}}
                    </td> -->
									</tr>
								</tbody>
								<thead>
									<tr>
										<th>{{ _traducao('global', 'pouso') }}:</th>
										<th>{{ _traducao('global', 'corte') }}:</th>
										<th>{{ _traducao('global', 'destino').capitalize() }}:</th>
										<th>{{ _traducao('global', 'estado') }}:</th>
										<th>{{ _traducao('global', 'cidade') }}:</th>
										<!-- <th>
                        {{_traducao('global','final')}}:
                    </th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td v-show="form.pouso != ''">
											{{ form.pouso }} ({{ _fusoHorario }})<br />
											<small>&nbsp;{{ form.pouso_utc }} (UTC)</small>
										</td>
										<td v-show="form.pouso == ''">N/A</td>
										<td>
											{{ form.corte }} ({{ _fusoHorario }})<br />
											<small>&nbsp;{{ form.corte_utc }} (UTC)</small>
										</td>
										<td>
											{{ form.para_select.sigla }}
										</td>
										<td>
											{{ form.nome_estado_para }}
										</td>
										<td>
											{{ form.nome_cidade_para }}
										</td>
										<!-- <td>
                        {{form.horimetro_final | horimetro}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- tempo de voo -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="9" style="background: #eee" class="text-center">
											{{ _traducao('global', 'tempoDeVoo').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<!-- <th style="width:14.28%">
						Tipo do Voo:
					</th> -->
										<th style="width: 14.28%">Total de Horas (Voo):</th>
										<th style="width: 14.28%">Total de Horas (Célula):</th>
										<th style="width: 14.28%">{{ _traducao('global', 'diurno') }}:</th>
										<th style="width: 14.28%">{{ _traducao('global', 'noturno') }}:</th>
										<th style="width: 14.28%">IFR:</th>
										<th style="width: 14.28%">{{ _traducao('global', 'navegacao') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<!-- <td>
						<span v-if="form.tipo_voo_pagamento == 'E'">EXPERIÊNCIA</span>
						<span v-if="form.tipo_voo_pagamento == null || form.tipo_voo_pagamento == ''">N/A</span>
						<span v-if="form.tipo_voo_pagamento == 'S'">SERVIÇO AÉREO</span>
					</td> -->
										<td>
											{{ form.tempo_voo_piloto | horimetro }}

											<small>({{ tempoVooPiloto }})</small>
										</td>
										<td>
											{{ form.tempo_voo_motor | horimetro }}
											<small>({{ tempoVooMotor }})</small>
										</td>
										<td>
											{{ form.hora_vfr_diurno }}
											<small>({{ form.vfr_diurno | horimetro }})</small>
										</td>
										<td>
											{{ form.hora_vfr_noturno }}
											<small>({{ form.vfr_noturno | horimetro }})</small>
										</td>
										<td>
											{{ form.hora_ifr }}
											<small>({{ form.ifr | horimetro }})</small>
										</td>
										<td>
											{{ form.hora_navegacao }}
											<small>({{ form.navegacao | horimetro }})</small>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- dados do voo -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="10" style="background: #eee" class="text-center">
											{{ _traducao('global', 'dadosDoVoo').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th style="width: 20%">{{ _traducao('global', 'combustivel') }}:</th>
										<th style="width: 20%">{{ _traducao('global', 'partidas') }}:</th>
										<th style="width: 20%">{{ _traducao('global', 'pousos') }}:</th>
										<th style="width: 20%" v-if="aeronave.tipo == 'H'">{{ _traducao('global', 'guincho') }}:</th>
										<th style="width: 20%" v-if="aeronave.tipo == 'H'">{{ _traducao('global', 'gancho') }}:</th>
									</tr>
									<tr>
										<td>{{ form.combustivel | horimetro }} {{ form.unidade_combustivel }}</td>
										<td>
											{{ form.partidas }}
										</td>
										<td>
											{{ form.pousos }}
										</td>
										<td v-if="aeronave.tipo == 'H'">
											{{ form.guincho }}
										</td>
										<td v-if="aeronave.tipo == 'H'">
											{{ form.gancho }}
										</td>
									</tr>
									<tr>
										<th style="width: 20%">PAX:</th>
										<th style="width: 20%">POB:</th>
										<th style="width: 20%">Tipo do Voo:</th>
										<th style="width: 20%">Horimetro de Célula Inicial:</th>
										<th style="width: 20%">Horimetro de Célula Final:</th>
									</tr>
									<tr>
										<td>
											{{ form.passageiro.length + form.tripulacao.length }}
										</td>
										<td>
											{{ form.passageiro.length }}
										</td>
										<td>
											<span v-if="form.tipo_voo_pagamento == 'E'">EXPERIÊNCIA</span>
											<span v-if="form.tipo_voo_pagamento == null || form.tipo_voo_pagamento == ''">N/A</span>
											<span v-if="form.tipo_voo_pagamento == 'S'">SERVIÇO AÉREO</span>
										</td>
										<td>
											{{ form.horimetro_manutencao | horimetro }}
										</td>
										<td>
											{{
												form.adiciona_horimetro_manutencao == '1'
													? form.horimetro_manutencao_final + 0.1
													: form.horimetro_manutencao_final | horimetro
											}}
											<small v-if="form.adiciona_horimetro_manutencao == '1'">(+1)</small>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- tripulacao -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="10" style="background: #eee" class="text-center">
											{{ _traducao('global', 'tripulacao').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'funcao') }}:</th>
										<th>{{ _traducao('global', 'nome') }}:</th>
										<th>{{ _traducao('global', 'anac') }}:</th>
										<th>{{ _traducao('global', 'apresentacao') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in form.tripulacao" :key="index">
										<td>
											<!-- <span v-if="form.voo_instrucao == '0'">{{item.funcao.toUpperCase()}}</span> -->
											<span>
												<span v-if="item.funcao == 'Piloto em Comando'"> 1º PILOTO EM COMANDO </span>
												<span v-else-if="item.funcao == 'Copiloto'">2º PILOTO EM COMANDO</span>
												<span v-else>
													{{ item.funcao.toUpperCase() }}
												</span>
											</span>
										</td>
										<td>
											<span v-for="it in item.usuarios" :key="it.id_usuario"
												><span v-if="it.id_usuario == item.id_usuario">{{ it.trigrama }} - {{ it.nome }}</span></span
											>
										</td>
										<td>
											{{ item.anac == '' || item.anac == null ? 'N/A' : item.anac }}
										</td>
										<td>
											{{ item.apresentacao }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- passageiros -->
							<table v-if="tipo == 'C' && passageiros.length > 0" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="10" style="background: #eee" class="text-center">
											{{ _traducao('global', 'passageiros').toUpperCase() }}
										</th>
									</tr>
									<tr v-if="passageiros.length > 0">
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('global', 'orgao') }}</th>
										<th>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in passageiros" :key="index">
										<td>{{ item.nome | na }}</td>
										<td>{{ item.orgao | na }}</td>
										<td>{{ item.cargo | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>{{ item.telefone | na }}</td>
									</tr>
									<tr>
										<td colspan="10" v-if="passageiros.length == 0" class="text-center">
											{{ _traducao('global', 'semPassageiros').toUpperCase() }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- vitimas -->
							<table v-if="tipo == 'C' && vitimas.length > 0" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="10" style="background: #eee" class="text-center">
											{{ _traducao('global', 'vitimas').toUpperCase() }}
										</th>
									</tr>
									<tr v-if="vitimas.length > 0">
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('global', 'sexo') }}</th>
										<th>{{ _traducao('global', 'dataNascimento') }}</th>
										<th>{{ _traducao('global', 'idadeAparente') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in vitimas" :key="index">
										<td>{{ item.nome | na }}</td>
										<td>{{ item.sexo | na }}</td>
										<td>{{ item.data_nascimento | data }}</td>
										<td>{{ item.idade_aparente | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>{{ item.telefone | na }}</td>
									</tr>
									<tr>
										<td colspan="10" v-if="vitimas.length == 0" class="text-center">
											{{ _traducao('global', 'semVitimas').toUpperCase() }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- cargas -->
							<table v-if="tipo == 'C' && form.carga == 'S'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="3" style="background: #f0f0f0" class="text-center">
											{{ _traducao('global', 'cargaTransportada').toUpperCase() }}
										</th>
									</tr>
									<tr v-if="form.carga == 'S'">
										<th>{{ _traducao('global', 'descricao') }}:</th>
										<th>{{ _traducao('global', 'pesoAprox') }}:</th>
										<th>{{ _traducao('global', 'cargaLiquida') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.carga == 'N'">
										<td colspan="3" class="text-center">
											{{ _traducao('global', 'naoHaCarga').toUpperCase() }}
										</td>
									</tr>
									<tr v-if="form.carga == 'S'">
										<td>
											{{ form.descricao_carga }}
										</td>
										<td>
											{{ form.peso_carga }}
										</td>
										<td>
											{{
												form.carga_liquida == 'S'
													? _traducao('global', 'sim').toUpperCase()
													: _traducao('global', 'nao').toUpperCase()
											}}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- <pre>{{form.discrepancia}}</pre> -->
							<!-- discrepancias -->
							<table
								v-if="(tipo == 'C' || tipo == 'I') && form.discrepancia.length > 0"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th colspan="4" style="background: #f0f0f0" class="text-center">DISCREPÂNCIAS TÉCNICAS</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.discrepancia.length == 0">
										<td colspan="4" class="text-center">
											{{ _traducao('global', 'naoHaDiscrepancia').toUpperCase() }}
										</td>
									</tr>
									<tr v-for="(item, idx) in form.discrepancia" :key="idx">
										<td>
											<div class="row">
												<div class="col-xs-2">
													<strong>{{ _traducao('global', 'tipo') }}:</strong><br />
													<span v-if="item.tipo == 'DISCREPANCIA'">{{ _traducao('global', 'discrepancia').toUpperCase() }}</span>
													<span v-if="item.tipo == 'OCORRENCIA'">{{
														_traducao('menuVoo', 'menuVocorrencia').toUpperCase()
													}}</span>
												</div>
												<div class="col-xs-3">
													<strong>{{ _traducao('global', 'nome') }} - ANAC:</strong> <br />
													{{ item.nome_usuario_discrepancia }} - {{ item.anac | na }}
												</div>
												<div class="col-xs-6">
													<strong>{{ _traducao('global', 'descricao') }}:</strong><br />
													{{ item.descricao }}
												</div>
											</div>

											<div v-if="item.acao_discrepancia.length > 0" style="border: 1px solid #ddd; padding: 4px; margin-top: 4px">
												<!-- <hr style="margin-bottom:4px; margin-top:4px" /> -->
												<div class="row" v-if="item.acao_discrepancia.length > 0">
													<div class="col-xs-12 text-center">
														<strong>AÇÕES TOMADAS</strong>
													</div>
												</div>
												<hr style="margin-bottom: 4px; margin-top: 4px" />

												<div v-for="(itAcao, idxAcao) in item.acao_discrepancia" :key="idxAcao">
													<div class="row">
														<div class="col-xs-2">
															<strong>Ação:</strong> <br />
															<span v-if="itAcao.tipo_acao == 'C'">{{ _traducao('global', 'acaoCorretiva').toUpperCase() }}</span>
															<span v-if="itAcao.tipo_acao == 'P'">{{
																_traducao('global', 'acaoPreventiva').toUpperCase()
															}}</span>
															<span v-if="itAcao.tipo_acao == 'M'">{{ _traducao('global', 'monitoramento').toUpperCase() }}</span>
															<span v-if="itAcao.tipo_acao == 'I'">{{
																_traducao('global', 'indisponibilizarAeronave').toUpperCase()
															}}</span>
														</div>
														<div class="col-xs-3">
															<strong>Nome - ANAC:</strong> <br />
															{{ itAcao.nome }} - {{ itAcao.codigo_anac }}
														</div>
														<div class="col-xs-3">
															<strong>Data:</strong> <br />
															{{ itAcao.data_cadastro | dataTempo }}
														</div>
														<div class="col-xs-4">
															<strong>Descrição:</strong> <br />
															{{ itAcao.descricao_acao }}
														</div>
													</div>
												</div>

												<div v-if="item.data_conclusao">
													<hr style="margin-bottom: 4px; margin-top: 4px" />
													<div class="row">
														<div class="col-xs-12 text-center">
															<strong>CONCLUSÃO</strong>
														</div>
													</div>
													<hr style="margin-bottom: 4px; margin-top: 4px" />

													<div class="row">
														<div class="col-xs-2">
															<strong>Data:</strong><br />
															{{ item.data_conclusao | dataTempo }}
														</div>
														<div class="col-xs-3">
															<strong>{{ _traducao('global', 'nome') }} - ANAC:</strong> <br />
															{{ item.nome_usuario_conclusao }} - {{ item.anac_usuario_conclusao | na }}
														</div>
													</div>
												</div>
											</div>
										</td>
										<!-- <td>
                        {{item.nome_usuario_discrepancia}}
                    </td>
                    <td>
                        {{item.anac | na}}
                    </td>
                    <td>
                        {{item.descricao}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- OCORRENCIAAS -->
							<table v-if="tipo == 'C' && form.ocorrencias.length > 0" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="5" style="background: #f0f0f0" class="text-center">OCORRÊNCIAS</th>
									</tr>
									<tr v-if="form.ocorrencias.length > 0">
										<th>Data:</th>
										<th>Local</th>
										<th>Código Classificação:</th>
										<th>Qualificação Civil:</th>
										<th>Descrição dos Fatos:</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="form.ocorrencias.length == 0">
										<td colspan="5" class="text-center">NÃO HÁ OCORRÊNCIAS</td>
									</tr>
									<tr v-for="(item, idx) in form.ocorrencias" :key="idx">
										<td>
											{{ item.data }}
										</td>
										<td>
											{{ item.local }}
										</td>
										<td>
											{{ item.codigo_classificacao }}
										</td>
										<td>
											{{ item.qualificacao_civil }}
										</td>
										<td>
											{{ item.descricao_fatos }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- despacho -->
							<table v-if="despacho != '' && tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="4" style="background: #f0f0f0" class="text-center">
											{{ _traducao('global', 'despachoDeAeronaves').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th style="width: 15%">{{ _traducao('global', 'codigo') }}:</th>
										<th style="width: 15%">{{ _traducao('global', 'data') }}:</th>
										<th style="width: 50%">{{ _traducao('global', 'historico') }}:</th>
										<!-- <th style="width:20%" >Finalizada?</th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.numero }}
										</td>
										<td>
											{{ despacho.data_inicio | dataTempo }}
										</td>
										<td style="white-space: inherit">
											{{ despacho.historico }}
										</td>
										<!-- <td>
                        {{form.finalizar_despacho == 1 ? 'SIM' : 'NÃO'}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- ordem de missao -->
							<table
								v-if="despacho != '' && despacho.id_ordem_missao != null && tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th colspan="4" style="background: #f0f0f0" class="text-center">
											{{ _traducao('global', 'ordemDeMissao').toUpperCase() }}
										</th>
									</tr>
									<tr>
										<th style="width: 15%">{{ _traducao('global', 'codigo') }}:</th>
										<th style="width: 15%">{{ _traducao('global', 'data') }}:</th>
										<th style="width: 50%">{{ _traducao('global', 'historico') }}:</th>
										<!-- <th style="width:20%" >Finalizada?</th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.ordem_codigo }}
										</td>
										<td>
											{{ despacho.ordem_data_inicio | dataTempo }}
										</td>
										<td v-html="despacho.ordem_descricao" style="white-space: inherit"></td>
										<!-- <td>
                        {{form.finalizar_despacho == 1 ? 'SIM' : 'NÃO'}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- prevenção qualificada -->
							<table
								v-if="despacho != '' && despacho.id_prevencao_qualificada != null && tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th colspan="4" style="background: #f0f0f0" class="text-center">PREVENÇÃO QUALIFICADA</th>
									</tr>
									<tr>
										<th style="width: 15%">{{ _traducao('global', 'codigo') }}:</th>
										<th style="width: 15%">{{ _traducao('global', 'inicio') }}:</th>
										<th style="width: 15%">{{ _traducao('global', 'fim') }}:</th>
										<th style="width: 50%">{{ _traducao('global', 'descricao') }}:</th>
										<!-- <th style="width:20%" >Finalizada?</th> -->
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.prevencao_codigo }}
										</td>
										<td>
											{{ despacho.prevencao_inicio | dataTempo }}
										</td>
										<td>
											{{ despacho.prevencao_fim | dataTempo }}
										</td>
										<td v-html="despacho.prevencao_descricao" style="white-space: inherit"></td>
										<!-- <td>
                        {{form.finalizar_despacho == 1 ? 'SIM' : 'NÃO'}}
                    </td> -->
									</tr>
								</tbody>
							</table>

							<!-- SOLICITAÇÃO -->
							<table
								v-if="despacho != '' && despacho.id_solicitacao != null && tipo == 'C'"
								class="table table-bordered table-condensed table-siga"
							>
								<thead>
									<tr>
										<th colspan="4" style="background: #f0f0f0" class="text-center">SOLICITAÇÃO DE USO DE AERONAVE</th>
									</tr>
									<tr>
										<th style="width: 15%">{{ _traducao('global', 'codigo') }}:</th>
										<th style="width: 50%">{{ _traducao('global', 'descricao') }}:</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											{{ despacho.solicitacao_codigo }}
										</td>
										<td style="white-space: inherit">
											{{ despacho.solicitacao_descricao }}
										</td>
									</tr>
								</tbody>
							</table>

							<!-- dados da missao -->
							<table v-if="tipo == 'C'" class="table table-bordered table-condensed table-siga">
								<thead>
									<tr>
										<th colspan="16" style="background: #f0f0f0" class="text-center">
											{{ _traducao('global', 'dadosDaMissao').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<!-- <tr>
                    <td colspan="4">
                        <strong>Origem:</strong><br/>
                        <span v-if="form.tipo_voo == 'E'">{{_traducao('global', 'emergencial').toUpperCase()}}</span>
                        <span v-if="form.tipo_voo == 'C'">{{_traducao('global', 'critica').toUpperCase()}}</span>
                        <span v-if="form.tipo_voo == 'P'">{{_traducao('global', 'planejada').toUpperCase()}}</span>
                    </td>
                    <td colspan="4">
                        <strong>Base:</strong><br/>
                        <span v-if="form.base == 1">1ª BRAvE</span>
                        <span v-if="form.base == 2">2ª BRAvE</span>
                        <span v-if="form.base == 3">3ª BRAvE</span>
                        <span v-if="form.base == 4">4ª BRAvE</span>
                        <span v-if="form.base == 5">5ª BRAvE</span>
                    </td>
                    <td colspan="2">
                        <strong>{{_traducao('global', 'numReds')}}:</strong><br/>
                        {{form.numero_bo | na}}
                    </td>
                    <td colspan="2">
                        <strong>{{_traducao('global', 'numChamada')}}:</strong><br/>
                        {{form.numero_chamada | na}}
                    </td>
                    <td colspan="2">
                        <strong>{{_traducao('global', 'numAtividade')}}:</strong><br/>
                        {{form.numero_atividade | na}}
                    </td>
                </tr> -->
									<tr>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'origem') }}:</strong>
										</td>
										<td colspan="6">
											<span v-if="form.tipo_voo == 'E'">{{ _traducao('global', 'emergencial').toUpperCase() }}</span>
											<span v-if="form.tipo_voo == 'C'">{{ _traducao('global', 'critica').toUpperCase() }}</span>
											<span v-if="form.tipo_voo == 'P'">{{ _traducao('global', 'planejada').toUpperCase() }}</span>
										</td>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'base') }}:</strong>
										</td>
										<td colspan="4">
											<span v-for="b in bases" :key="b.id"
												><span v-if="b.id == form.base">{{ b.descricao }}</span></span
											>
										</td>
									</tr>
									<tr>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'numChamada') }}:</strong>
										</td>
										<td colspan="6">
											{{ form.numero_chamada | na }}
										</td>
										<td colspan="2" style="width: 15%">
											<strong>Nº CIOPS:</strong>
										</td>
										<td colspan="4">
											{{ form.numero_bo | na }}
										</td>
									</tr>
									<tr>
										<td colspan="2" style="width: 15%">
											<strong>Tipo do Voo:</strong>
										</td>
										<td colspan="6" v-if="form.tipo_missao">
											{{ form.tipo_missao.descricao }}
										</td>
										<td colspan="2" style="width: 17%">
											<strong>Tipo:</strong>
										</td>
										<td colspan="4">
											<span v-if="form.tipo_classificacao == 'P'">PREVENÇÃO</span>
											<span v-if="form.tipo_classificacao == 'R'">REPRESSÃO</span>
											<span v-if="form.tipo_classificacao == '' || form.tipo_classificacao == null">N/A</span>
										</td>
									</tr>
									<!-- SE FOR PMSP -->
									<tr v-if="_idCliente == 14">
										<td colspan="2">
											<strong>{{ _traducao('global', 'acoes') }}:</strong>
										</td>
										<!-- Auto Localização -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'autoLocalizacao') }}:</strong><br />
											{{ form.auto_localizado }}
										</td>

										<!-- Armas Apreendidas -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'armasApreendidas') }}:</strong><br />
											{{ form.arma_apreendida }}
										</td>

										<!-- Pessoas Detidas -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'pessoasDetidas') }}:</strong><br />
											{{ form.pessoa_detida }}
										</td>

										<!-- Pessoas Salvas -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'pessoasSalvas') }}:</strong><br />
											{{ form.pessoa_salva }}
										</td>

										<!-- Valor Recuperado -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'valorRecuperado') }}:</strong><br />
											{{ form.valor_recuperado | moeda }}
										</td>
									</tr>
									<tr v-if="form.tipo_missao.descricao == 'TRANSPORTE DE ÓRGÃOS E TECIDOS' || form.tipo_missao == 'SAÚDE / SOCORRO'">
										<!-- CORACAO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'coracao') }}:</strong><br />
											{{ form.coracao }}
										</td>

										<!-- RIM -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'rim') }}:</strong><br />
											{{ form.rim }}
										</td>

										<!-- FIGADO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'figado') }}:</strong><br />
											{{ form.figado }}
										</td>

										<!-- CORNEA -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'cornea') }}:</strong><br />
											{{ form.cornea }}
										</td>

										<!-- ESCLERO -->
										<td colspan="2">
											<strong>{{ _traducao('global', 'esclero') }}:</strong><br />
											{{ form.esclero }}
										</td>

										<!-- BAÇO -->
										<td colspan="5">
											<strong>{{ _traducao('global', 'baco') }}:</strong><br />
											{{ form.baco }}
										</td>
									</tr>
									<tr
										v-if="
											form.tipo_missao.descricao == 'MEIO AMBIENTE' ||
											form.tipo_missao.descricao == 'COMBATE A INCÊNDIO' ||
											form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'
										"
									>
										<td colspan="16">
											<table class="table table-bordered table-condensed table-siga" style="margin-top: -3px">
												<tbody>
													<!-- UNIDADE DE CONSERVAÇÃO -->
													<td v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'">
														<strong>{{ _traducao('global', 'unidadeDeConservacao') }}:</strong><br />
														<div v-if="form.existe_unidade_conservacao == '1'">
															<div v-for="(un, k) in form.unidade_conservacao" :key="k">{{ un.obj.sigla }}</div>
														</div>
														<div v-if="form.existe_unidade_conservacao == '0'">NÃO</div>
													</td>

													<!-- BASE ORIGEM -->
													<td v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'">
														<strong>{{ _traducao('global', 'baseDeOrigem') }}:</strong><br />
														{{ form.base_origem | na }}
													</td>

													<!-- BAMBI
                                <td v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE' || form.tipo_missao.descricao == 'COMBATE A INCÊNDIO'">
                                    <strong>{{_traducao('global','bambiBucket')}}:</strong><br/>
                                    {{form.bambi}}
                                </td> -->

													<!-- BRIGADISTAS -->
													<td v-if="form.tipo_missao.descricao == 'MEIO AMBIENTE'">
														<strong>{{ _traducao('global', 'brigadistas') }}:</strong><br />
														{{ form.brigadista }}
													</td>
													<!-- BUSCA E SALVAMENTO -->
													<td v-if="form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'">
														<strong>{{ _traducao('global', 'socorridos') }}:</strong><br />
														{{ form.socorrido }}
													</td>
												</tbody>
											</table>
										</td>
									</tr>

									<tr>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'classificacao') }}:</strong>
										</td>
										<td colspan="6">
											{{ form.classificacao.descricao.toUpperCase() }}
										</td>
										<td colspan="2" style="width: 15%">
											<strong>{{ _traducao('global', 'subclassificacao') }}:</strong>
										</td>
										<td colspan="4">
											<span v-if="form.subclassificacao != '' && form.subclassificacao != null">{{
												form.subclassificacao.descricao.toUpperCase()
											}}</span>
											<span v-if="form.subclassificacao == '' || form.subclassificacao == null">N/A</span>
										</td>
									</tr>

									<tr>
										<td colspan="2" style="width: 15%">
											<strong>Objetivos alcançados?</strong>
										</td>
										<td colspan="6">
											<span v-if="form.objetivo_alcancado == 'S'">{{ _traducao('global', 'sim') }}</span>
											<span v-if="form.objetivo_alcancado == 'P'">Parcial</span>
											<span v-if="form.objetivo_alcancado == 'N'">{{ _traducao('global', 'nao') }}</span>
											<span v-if="form.objetivo_alcancado == ''">N/A</span>
										</td>
										<td colspan="2" style="width: 17%">
											<strong>{{ _traducao('global', 'contextoOperativo') }}:</strong>
										</td>
										<td colspan="4">
											<span v-if="form.houve_contexto == '1'">{{ form.contexto_operativo.descricao.toUpperCase() }}</span>
											<span v-if="form.houve_contexto == '0'">N/A</span>
										</td>

										<!-- <td colspan="2" style="width:15%">
                        <strong>{{_traducao('global', 'contextoOperativo')}}:</strong>
                    </td>
                    <td colspan="14">
                        <span v-if="form.houve_contexto == '1'">{{form.contexto_operativo.descricao.toUpperCase()}}</span>
                        <span v-if="form.houve_contexto == '0'">N/A</span>
                    </td> -->
									</tr>

									<tr>
										<td colspan="2">
											<strong>{{ _traducao('global', 'orgaoApoiado') }}:</strong>
										</td>
										<td colspan="6">
											<span v-for="(itOrgao, idxOrgao) in form.orgao" :key="idxOrgao">
												{{ itOrgao.orgao.sigla
												}}<strong v-for="(unid, indexUnid) in form.orgao[idxOrgao].unidade" :key="indexUnid">
													({{ form.orgao[idxOrgao].unidade[indexUnid].unidade.descricao }})</strong
												><span v-html="idxOrgao < form.orgao.length - 1 ? ',' : '.'"></span>
											</span>
											<span v-if="form.orgao.length == 0"> N/A </span>
										</td>
										<td colspan="2">
											<strong>Diário de Bordo Físico:</strong>
										</td>
										<td colspan="6">
											<span>
												{{ form.diario_fisico | na }}
											</span>
										</td>
									</tr>

									<tr>
										<td colspan="2">
											<strong>Observação:</strong>
										</td>
										<td colspan="14" style="white-space: inherit">
											{{ form.observacao }}
										</td>
									</tr>
								</tbody>
							</table>

							<table
								class="table table-bordered table-condensed table-siga"
								style="margin-top: 10px !important"
								v-if="(form.nome_usuario_assinou != '' || form.nome_mecanico_assinou != '') && tipo == 'C'"
							>
								<tbody>
									<tr>
										<td>
											<div class="row">
												<div class="col-xs-2">
													<!-- <i style="font-size: 300px" class="fa icon-assinatura_eletronica_03"></i> -->
													<img class="img-responsive img-ass" src="../../../../../assets/img/assinatura_eletronica.png" />
												</div>

												<div class="col-xs-10">
													<p
														style="margin-top: 4px !important; margin-bottom: 4px !important"
														v-if="form.nome_usuario_assinou != ''"
													>
														Assinado digitalmente pelo 1° piloto em comando <strong>{{ form.nome_usuario_assinou }}</strong> em
														<strong>{{ form.data_assinatura_piloto | dataTempo }}</strong
														>.
													</p>
													<p v-if="form.nome_mecanico_assinou != ''">
														Assinado digitalmente pelo mecânico <strong>{{ form.nome_mecanico_assinou }}</strong> em
														<strong>{{ form.data_assinatura_mecanico | dataTempo }}</strong
														>.
													</p>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>

							<!-- posicoes -->
							<table class="table table-bordered table-condensed table-siga no-print" v-if="posicoes.length > 0 && voo">
								<thead>
									<tr>
										<th colspan="16" style="background: #f0f0f0" class="text-center">
											{{ _traducao('global', 'voo').toUpperCase() }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div ref="map" style="width: 100%; height: 450px"></div>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</table>

				<!-- <flDocumentoQrCode  v-if="form.chave_validacao != '' && tipo == 'C'" :chaveValidacao="form.chave_validacao" /> -->
			</div>

			<flGeradoPor />

			<pre style="display: none">
			{{ form }}
		</pre
			>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		name: String,
		cabecalho: Boolean,
		voo: {
			type: Boolean,
			default: true,
			required: false
		}
	},

	computed: {
		tempoVooMotor() {
			var dec = moment(this.form.decolagem, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)
			var pouso = moment(this.form.pouso, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)

			var diff = pouso.diff(dec)
			var duration = moment.duration(diff)

			var $hours = duration.hours()
			var $days = duration.days()
			var $minutes = duration.minutes()

			var hora = ''
			var minuto = ''

			if (!_.isNil($hours)) {
				if (Number($hours) < 10) {
					hora = '0' + $hours
				} else {
					hora = $hours
				}
			} else {
				hora = '00'
			}

			if (!_.isNil($minutes)) {
				if (Number($minutes) < 10) {
					minuto = '0' + $minutes
				} else {
					minuto = $minutes
				}
			} else {
				minuto = '00'
			}

			var h = Number(hora) + $days * 24
			return (h < 10 ? '0' + h : h) + ':' + minuto
		},

		tempoVooPiloto() {
			var dec = moment(this.form.acionamento, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)
			var pouso = moment(this.form.corte, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)

			var diff = pouso.diff(dec)
			var duration = moment.duration(diff)

			var $hours = duration.hours()
			var $days = duration.days()
			var $minutes = duration.minutes()

			var hora = ''
			var minuto = ''

			if (!_.isNil($hours)) {
				if (Number($hours) < 10) {
					hora = '0' + $hours
				} else {
					hora = $hours
				}
			} else {
				hora = '00'
			}

			if (!_.isNil($minutes)) {
				if (Number($minutes) < 10) {
					minuto = '0' + $minutes
				} else {
					minuto = $minutes
				}
			} else {
				minuto = '00'
			}

			var h = Number(hora) + $days * 24
			return (h < 10 ? '0' + h : h) + ':' + minuto
		}
	},

	data() {
		return {
			pdf: false,
			exibir: false,
			form: {
				para_select: '',
				de_select: '',
				passageiro: [],
				tripulante: [],
				discrepancia: [],
				orgao: [],
				voo: null
			},
			tipo: 'C',

			aeronave: {
				prefixo: '',
				codinome: '',
				tipo: '',
				modelo: '',
				serial_number: null,
				tripulacao: [],
				passageiro: []
			},

			motores: [],

			configMapa: {
				lat: 0,
				long: 0,
				zoom: 0
			},

			posicoes: [],
			bases: [],

			trilhas: [],
			markers: [],
			map: null,

			passageiros: [],
			vitimas: [],

			ordem: '',
			despacho: '',
			pilotos: '',

			subclassificacoes: [],
			classificacoes: []
		}
	},

	mounted() {
		this._providerBaseOperacional((lista) => (this.bases = lista))
	},

	methods: {
		carregaDados(obj) {
			this.carregaDados(obj)
		},

		carregaOrdem(ordem) {
			this.ordem = ordem
		},

		carregaDespacho(despacho) {
			this.despacho = despacho
		},

		geraMapa(posicoes) {
			this.configMapa.lat = Number($cliente.getVersao('lat_inicio'))
			this.configMapa.long = Number($cliente.getVersao('long_inicio'))
			this.configMapa.zoom = 11

			// exluir e inicia um novo mapa
			this.initMap(this.configMapa.lat, this.configMapa.long, this.configMapa.zoom)

			var bounds = new google.maps.LatLngBounds()
			this.removPolylines(null)
			this.trilhas = []
			this.removeMarkers(null)
			this.markers = []

			var polyTrilha = []

			var latInit = parseFloat(posicoes[0].lat)
			var lgnInit = parseFloat(posicoes[0].lng)

			var lenghPlots = posicoes.length

			for (var i in posicoes) {
				polyTrilha.push({lat: Number(posicoes[i].lat), lng: Number(posicoes[i].lng)})
				this.geraMarkers(posicoes[i], Number(i), lenghPlots)
				bounds.extend(polyTrilha[i])
			}

			// polyline com o movimento
			var polylineLinhaConfig = new google.maps.Polyline({
				strokeColor: $cliente.getVersao('cor_polilyne'),
				path: polyTrilha,
				strokeOpacity: 1,
				icons: [
					{
						scale: 0.8,
						icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
						offset: '1',
						repeat: '90px'
					}
				]
			})

			polylineLinhaConfig.setMap(this.map)

			// add as poly na lista
			this.trilhas.push(polylineLinhaConfig)
			this.map.fitBounds(bounds)
		},

		getTipoVelocidade(versao, item) {
			if (versao == 'S') {
				return item.velocidade_km
			}

			return item.velocidade
		},

		// Gera o rastro da aeronave
		geraMarkers(item, i, lenghPlots) {
			var strginInfo = ''
			var marker = ''
			var img = ''

			if (i == 0) {
				var img = new google.maps.MarkerImage(
					this._getPin('verde'),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					null, //new google.maps.Point(20, 20),
					null
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo += '<strong>' + this._traducao('global', 'inicio').toUpperCase() + '</strong>'
				strginInfo += '</td></tr>'
			} else if (i == lenghPlots - 1) {
				var img = new google.maps.MarkerImage(
					this._getPin('azul'),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					null, //new google.maps.Point(20, 20),
					null //new google.maps.Size(18, 30)
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo += '<strong>' + this._traducao('global', 'fim').toUpperCase() + '</strong>'
				strginInfo += '</td></tr>'
			} else {
				var img = new google.maps.MarkerImage(
					this._getLinkImage(item.tipo, 'N', item.direcao, item.cor, true, item.icone),
					null, //new google.maps.Size(65, 65, "px", "px"),
					null, // new google.maps.Point(0, 0),
					new google.maps.Point(20, 20),
					new google.maps.Size(40, 40)
				)

				strginInfo = "<table style='width:100%'>"
				strginInfo += "<tr style='border-bottom:1px solid #F0F0F0'>"
				strginInfo += "<td style='padding:1px 10px 10px 10px;color: #1976D2; font-size:14px'>"
				strginInfo += '<strong>' + this._traducao('global', 'posicao').toUpperCase() + ' ' + (i + 1) + ' ' + '</strong>'
				strginInfo += '</td></tr>'
			}

			// informacoes de posicoes
			strginInfo += '<tr>'
			strginInfo += "<td style='padding:10px'>"
			strginInfo += '<table>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{HORA}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.hora +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{VELOCIDADE}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				this.getTipoVelocidade(this._versaoSistema, item) +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{ALTITUDE}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.altitude +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{DIRECAO}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.direcao +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{LAT}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.lat +
				'</td></tr>'
			strginInfo +=
				"<tr><td class='pd-table-gmap-aero'><strong>{{LNG}}</strong>: </td><td class='pd-table-gmap-aero'>" +
				item.lng +
				'</td></tr>'
			strginInfo += '</table>'
			strginInfo += '</td>'

			strginInfo += '</tr>'
			strginInfo += '</table>'

			strginInfo = strginInfo.replace('{{AERONAVE}}', this._traducao('global', 'aeronave').toUpperCase())
			strginInfo = strginInfo.replace('{{DATA}}', this._traducao('global', 'data').toUpperCase())
			strginInfo = strginInfo.replace('{{HORA}}', this._traducao('global', 'hora').toUpperCase())
			strginInfo = strginInfo.replace('{{VELOCIDADE}}', this._traducao('global', 'velocidade').toUpperCase())
			strginInfo = strginInfo.replace('{{ALTITUDE}}', this._traducao('global', 'altitude').toUpperCase())
			strginInfo = strginInfo.replace('{{DIRECAO}}', this._traducao('global', 'direcao').toUpperCase())
			strginInfo = strginInfo.replace('{{LAT}}', this._traducao('global', 'lat').toUpperCase())
			strginInfo = strginInfo.replace('{{LNG}}', this._traducao('global', 'lng').toUpperCase())

			var myLatLng = {lat: Number(item.lat), lng: Number(item.lng)}

			marker = new google.maps.Marker({
				position: myLatLng,
				map: this.map,
				options: {
					icon: img,
					animation: i == 0 || i == lenghPlots - 1 ? google.maps.Animation.DROP : null
				}
			})

			// gera o info view na aeronave
			marker.info = new google.maps.InfoWindow({
				content: strginInfo
			})

			// add o evento qnado passa o mouse
			google.maps.event.addListener(
				marker,
				'mouseover',
				((marker, i) => {
					return () => {
						marker.info.open(this.map, marker)
					}
				})(marker, i)
			)

			// add o vento quando sai o maou
			google.maps.event.addListener(
				marker,
				'mouseout',
				((marker, i) => {
					return () => {
						marker.info.close(this.map, marker)
					}
				})(marker, i)
			)

			this.markers.push(marker)
		},

		// remove se existir os markers do mapa
		removeMarkers(map) {
			for (var j = 0; j < this.markers.length; j++) {
				this.markers[j].setMap(null)
			}
		},

		// remove as polylines os markers do mapa
		removPolylines(map) {
			for (var j = 0; j < this.trilhas.length; j++) {
				this.trilhas[j].setMap(null)
			}
		},

		// inicia o mapa
		initMap(lat, lng, zoom) {
			this.map = null

			let latLong = new google.maps.LatLng(lat, lng)

			let mapOp = {
				//center: latLong,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				mapTypeControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
					//style : google.maps.MapTypeControlStyle.DROPDOWN_MENU
				},
				zoomControl: false,
				zoomControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
				},
				navigationControl: true,
				scrollwheel: true,
				fullscreenControl: false,
				streetViewControl: false
			}

			this.map = new google.maps.Map(this.$refs.map, mapOp)

			this._adicionaBotoes(this.map)

			//////////console.log(this.area)
		},

		carregaDados(obj) {
			//////////console.log("form", obj.data)
			this.exibir = true
			this.form = obj.data
			this.aeronave = obj.aero
			this.pilotos = obj.pilotos
			this.posicoes = []
			this.vitimas = []
			this.passageiros = []
			this.trecho = obj.trecho

			if (this.form.hora_if != '00:00:00') {
				this.form.ifr = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_ifr)
			}

			if (this.form.hora_vfr_noturno != '00:00:00') {
				this.form.vfr_noturno = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_vfr_noturno)
			}

			if (this.form.hora_vfr_diurno != '00:00:00') {
				this.form.vfr_diurno = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_vfr_diurno)
			}

			if (this.form.hora_navegacao != '00:00:00') {
				this.form.navegacao = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_navegacao)
			}

			if (_.isNil(obj.data.motores)) {
				this.motores = []
			} else {
				this.motores = obj.data.motores
			}

			// tipo de exibição do diário: C: completo, I: incisos XIII a XVII do art. 4º da resolução 457
			if (!_.isNil(obj.tipo)) {
				this.tipo = obj.tipo
			} else {
				this.tipo = 'C'
			}

			if (this.form.id_ordem_missao == null) {
				this.ordem = ''
			}

			if (this.form.id_despacho_emergencial == null) {
				this.despacho = ''
			}

			for (var i in this.form.passageiro) {
				if (this.form.passageiro[i].tipo == 'V') {
					this.vitimas.push(this.form.passageiro[i])
				} else {
					this.passageiros.push(this.form.passageiro[i])
				}
			}

			if (this.voo == true) {
				if (obj.trecho.rastreado == true) {
					this._httpGet('cta-maranhao/Relatorio_voo_trecho/get_rastreamento/' + obj.data.id, (response) => {
						// bus.$emit('load-out')
						console.log('response', response)
						if (response._request) {
							this.posicoes = response.lista
							this.map = null
							this.$nextTick(() => {
								this.geraMapa(response.lista)
							})
						}
					})
				} else {
					this.map = null
				}
			} else {
				this.map = null
			}

			console.log('priiiint', this.form)
		}
	}
}
</script>